// opervex-frontend/src/layout/Sidebar/Sidebar.js

import Navigation from "./Navigation";

const Sidebar = ({ collapsed }) => {
  return (
    <aside className={`layout-sidebar ${collapsed ? "collapsed" : ""}`}>
      <Navigation collapsed={collapsed} />
    </aside>
  );
};

export default Sidebar;
